import { ReactNode } from 'react';

export interface IModalBodyProps {
    content: ReactNode;
}

export default function ModalBody(props: IModalBodyProps) {
    const { content } = props;
    return (
        <div className="nj-modal__body flex-1 min-h-0 flex flex-col">
            {content}
        </div>
    );
}
